import React from 'react';
import classNames from 'clsx';

import { useChannelConfig } from '@/modules/ChannelList/constants/carousels';

import { isVisibleInConfig } from '@/modules/common/helpers/configuration';

import { Skeleton } from '@/mui/components';

import styles from './Slide.module.scss';

type Props = {
  height: number;
};

function SlideSkeleton({ height }: Props) {
  const configByChannel = useChannelConfig();
  const videoCardTitleConfig = configByChannel.videoCard.title;
  const videoCardConfig = configByChannel.videoCard;
  const isVideoCardStatic = videoCardConfig.static ?? false;

  return (
    <div className={classNames(styles.Slide, styles.Slide___plug)}>
      <Skeleton variant="rectangular" width="100%" height={height} className={styles.SlideContainer} />
      {!isVideoCardStatic && isVisibleInConfig(videoCardTitleConfig.visible) && (
        <div className={styles.SlideTitle}>
          <Skeleton variant="text" width="100%" />
        </div>
      )}
    </div>
  );
}

export default SlideSkeleton;
